var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGenerate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.625 10.3306V6C11.625 3.64313 11.625 2.46437 10.8925 1.7325C10.16 1.00062 8.98187 1 6.625 1H6C3.64313 1 2.46437 1 1.7325 1.7325C1.00062 2.465 1 3.64313 1 6V11.9375",
    stroke: "#29C0BB",
    strokeWidth: 0.9375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.625 10.375H2.5625C2.1481 10.375 1.75067 10.5396 1.45765 10.8326C1.16462 11.1257 1 11.5231 1 11.9375C1 12.3519 1.16462 12.7493 1.45765 13.0424C1.75067 13.3354 2.1481 13.5 2.5625 13.5H11.625",
    stroke: "#29C0BB",
    strokeWidth: 0.9375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.625 13.5001C11.2106 13.5001 10.8132 13.3355 10.5201 13.0424C10.2271 12.7494 10.0625 12.352 10.0625 11.9376C10.0625 11.5232 10.2271 11.1258 10.5201 10.8327C10.8132 10.5397 11.2106 10.3751 11.625 10.3751M6.505 7.25009L5.59188 4.42447C5.56026 4.3354 5.50141 4.25856 5.42367 4.20482C5.34592 4.15109 5.25324 4.12319 5.15875 4.12509C5.06426 4.12319 4.97158 4.15109 4.89383 4.20482C4.81609 4.25856 4.75724 4.3354 4.72563 4.42447L3.8125 7.25009M8.1875 4.12509V7.25009M4.14875 6.31259H6.16813",
    stroke: "#29C0BB",
    strokeWidth: 0.9375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenerate);
export default __webpack_public_path__ + "static/media/generate.9d6c441d3e4a472650b00e0b2eac1572.svg";
export { ForwardRef as ReactComponent };